export default [
  { value: '1110', label: '1110 Insurance' },
  { value: '1120', label: '1120 Marine Contract Actions' },
  { value: '1130', label: '1130 Miller Act' },
  { value: '1140', label: '1140 Negotiable Instruments' },
  { value: '1150', label: '1150 Overpayments & Enforc. of Judgments' },
  { value: '1151', label: '1151 Overpayments Under Medicare Act' },
  { value: '1152', label: '1152 Recovery of Defaulted Student Loans' },
  { value: '1153', label: '1153 Recovery of Ovrpmnts of Vet Benefit' },
  { value: '1190', label: '1190 Other Contract Actions' },
  { value: '1195', label: '1195 Contract Product Liability' },
  { value: '1196', label: '1196 Franchise' },
  { value: '1210', label: '1210 Land Condemnation' },
  { value: '1220', label: '1220 Foreclosure' },
  { value: '1230', label: '1230 Rent, Lease, Ejectment' },
  { value: '1240', label: '1240 Torts To Land' },
  { value: '1245', label: '1245 Tort Product Liability' },
  { value: '1290', label: '1290 Other Real Property Actions' },
  { value: '1340', label: '1340 Marine Personal Injury' },
  { value: '1350', label: '1350 Motor Vehicle' },
  { value: '1360', label: '1360 Other Personal Injury' },
  { value: '1370', label: '1370 Other Fraud' },
  { value: '1371', label: '1371 Truth in Lending' },
  { value: '1380', label: '1380 Other Personal Property Damage' },
  { value: '1385', label: '1385 Property Damage - Product Liability' },
  { value: '1410', label: '1410 Antitrust' },
  { value: '1422', label: '1422 Bankruptcy Appeals Rule 28 USC 158' },
  { value: '1423', label: '1423 Bankruptcy Withdraw 28 USC 157' },
  { value: '1430', label: '1430 Banks and Banking' },
  { value: '1440', label: '1440 Other Civil Rights' },
  { value: '1441', label: '1441 Civil Rights Voting' },
  { value: '1442', label: '1442 Civil Rights Jobs' },
  { value: '1443', label: '1443 Civil Rights Accommodations' },
  { value: '1444', label: '1444 Civil Rights Welfare' },
  { value: '1445', label: '1445 American w/Disab.Act-Empl' },
  { value: '1446', label: '1446 Americans w/Disab Act - Other' },
  { value: '1450', label: '1450 Interstate Commerce' },
  { value: '1470', label: '1470 Civil (RICO)' },
  { value: '1480', label: '1480 Consumer Credit' },
  { value: '1490', label: '1490 Cable Satellite/TV' },
  { value: '1610', label: '1610 Agricultural Acts' },
  { value: '1620', label: '1620 Food and Drugs Acts' },
  { value: '1625', label: '1625 Drug Related Seizure of Property' },
  { value: '1630', label: '1630 Liquor Laws' },
  { value: '1640', label: '1640 Railroad and Trucks' },
  { value: '1650', label: '1650 Airline Regulations' },
  { value: '1660', label: '1660 Occupational Safety/Health' },
  { value: '1690', label: '1690 Other Forfeiture and Penalty Suits' },
  { value: '1710', label: '1710 Fair Labor Standards Act' },
  { value: '1720', label: '1720 Labor/Management Relations Act' },
  { value: '1730', label: '1730 Report & Disclosure' },
  { value: '1740', label: '1740 Railway Labor Act' },
  { value: '1790', label: '1790 Other Labor Litigation' },
  { value: '1791', label: '1791 Employee Retirement' },
  { value: '1830', label: '1830 Patent' },
  { value: '1840', label: '1840 Trademark' },
  { value: '1850', label: '1850 Securities, Commodities, Exchange' },
  { value: '1862', label: '1862 Black Lung' },
  { value: '1863', label: '1863 D.I.W.C./D.I.W.W.' },
  { value: '1870', label: '1870 Tax Suits' },
  { value: '1871', label: '1871 IRS 3rd Party Suits 26 USC 7609' },
  { value: '1890', label: '1890 Other Statutory Actions' },
  { value: '1891', label: '1891 Agricultural Acts' },
  { value: '1892', label: '1892 Economic Stabilization Act' },
  { value: '1893', label: '1893 Environmental Matters' },
  { value: '1894', label: '1894 Energy Allocation Act' },
  { value: '1950', label: '1950 Constitutionality of State Statutes' },
  { value: '1990', label: '1990 Other' },
  { value: '1999', label: '1999 Miscellaneous' },
  { value: '2110', label: '2110 Insurance' },
  { value: '2120', label: '2120 Marine Contract Actions' },
  { value: '2130', label: '2130 Miller Act' },
  { value: '2140', label: '2140 Negotiable Instruments' },
  { value: '2150', label: '2150 Ovrpmnts & Enforcement of Judgments' },
  { value: '2151', label: '2151 Overpayments Under Medicare Act' },
  { value: '2152', label: '2152 Recovery of Defaulted Student Loans' },
  { value: '2153', label: '2153 Recovery Overpayment Vet Benefits' },
  { value: '2190', label: '2190 Other Contract Actions' },
  { value: '2195', label: '2195 Contract Product Liability' },
  { value: '2196', label: '2196 Franchise' },
  { value: '2210', label: '2210 Land Condemnation' },
  { value: '2220', label: '2220 Foreclosure' },
  { value: '2230', label: '2230 Rent, Lease, Ejectment' },
  { value: '2240', label: '2240 Torts to Land' },
  { value: '2245', label: '2245 Tort Product Liability' },
  { value: '2290', label: '2290 Other Real Property Actions' },
  { value: '2310', label: '2310 Airplane Personal Injury' },
  { value: '2315', label: '2315 Airplane Product Liability' },
  { value: '2320', label: '2320 Assault, Libel, and Slander' },
  { value: '2330', label: '2330 Federal Employers\' Liability' },
  { value: '2340', label: '2340 Marine Personal Injury' },
  { value: '2345', label: '2345 Marine - Product Liability' },
  { value: '2350', label: '2350 Motor Vehicle' },
  { value: '2355', label: '2355 Motor Vehicle Product Liability' },
  { value: '2360', label: '2360 Other Personal Injury' },
  { value: '2362', label: '2362 Medical Malpractice' },
  { value: '2365', label: '2365 Personal Injury - Product Liability' },
  { value: '2368', label: '2368 Asbestos Personal Injury-Product Liability' },
  { value: '2370', label: '2370 Other Fraud' },
  { value: '2371', label: '2371 Truth in Lending' },
  { value: '2380', label: '2380 Other Personal Property Damage' },
  { value: '2385', label: '2385 Property Damage-Product Liability' },
  { value: '2410', label: '2410 Antitrust' },
  { value: '2422', label: '2422 Bankruptcy Appeals Rule 28 USC 158' },
  { value: '2423', label: '2423 Bankruptcy Withdrawal 28 USC 157' },
  { value: '2430', label: '2430 Banks and Banking' },
  { value: '2440', label: '2440 Other Civil Rights' },
  { value: '2441', label: '2441 Civil Rights Voting' },
  { value: '2442', label: '2442 Civil Rights Jobs' },
  { value: '2443', label: '2443 Civil Rights Accommodations' },
  { value: '2444', label: '2444 Civil Rights Welfare' },
  { value: '2445', label: '2445 Americans w/Disab.Act-Empl' },
  { value: '2446', label: '2446 Americans w/Disab Act - Other' },
  { value: '2450', label: '2450 Interstate Commerce' },
  { value: '2460', label: '2460 Deportation' },
  { value: '2462', label: '2462 Naturalization Application' },
  { value: '2463', label: '2463 Habeas Corpus- Alien Detainee' },
  { value: '2465', label: '2465 Other Immigration Actions' },
  { value: '2480', label: '2480 Consumer Credit' },
  { value: '2490', label: '2490 Cable Satellite/TV' },
  { value: '2510', label: '2510 Prisoner Petitions - Vacate Sentence' },
  { value: '2530', label: '2530 Habeas Corpus' },
  { value: '2535', label: '2535 Habeas Corpus: Death Penalty' },
  { value: '2540', label: '2540 Prisoner Petitions - Mandamus & Other' },
  { value: '2550', label: '2550 Prisoner - Civil Rights' },
  { value: '2555', label: '2555 Prison Condition' },
  { value: '2610', label: '2610 Agricultural Acts' },
  { value: '2620', label: '2620 Food and Drug Acts' },
  { value: '2625', label: '2625 Drug Related Seizure of Property' },
  { value: '2630', label: '2630 Liquor Laws' },
  { value: '2640', label: '2640 Railroad and Trucks' },
  { value: '2650', label: '2650 Airline Regulations' },
  { value: '2660', label: '2660 Occupational Safety/Health' },
  { value: '2690', label: '2690 Other Forfeiture and Penalty Suits' },
  { value: '2710', label: '2710 Fair Labor Standards Act' },
  { value: '2720', label: '2720 Labor Management Relations Act' },
  { value: '2730', label: '2730 Labor/Management Rept & Disclsure' },
  { value: '2740', label: '2740 Railway Labor Act' },
  { value: '2790', label: '2790 Other Labor Litigation' },
  { value: '2791', label: '2791 Employee Retirement' },
  { value: '2810', label: '2810 Selective Service' },
  { value: '2830', label: '2830 Patent' },
  { value: '2850', label: '2850 Securities, Commodities, Exch.' },
  { value: '2860', label: '2860 Social Security' },
  { value: '2861', label: '2861 Medicare' },
  { value: '2862', label: '2862 Black Lung' },
  { value: '2863', label: '2863 D.I.W.C./D.I.W.W.' },
  { value: '2864', label: '2864 S.S.I.D.' },
  { value: '2865', label: '2865 R.S.I.' },
  { value: '2870', label: '2870 Tax Suits' },
  { value: '2871', label: '2871 IRS 3rd Party Suits 26 USC 7609' },
  { value: '2875', label: '2875 Customer Challenge 12 USC 3410' },
  { value: '2890', label: '2890 Other Statutory Actions' },
  { value: '2891', label: '2891 Agricultural Acts' },
  { value: '2892', label: '2892 Economic Stabilization Act' },
  { value: '2893', label: '2893 Environmental Matters' },
  { value: '2894', label: '2894 Energy Allocation Act' },
  { value: '2895', label: '2895 Freedom of Information Act of 1974' },
  { value: '2900', label: '2900 Appeal of Fee -Equal Access Justice' },
  { value: '2950', label: '2950 Constitutionality of State Statutes' },
  { value: '2990', label: '2990 Other' },
  { value: '2999', label: '2999 Miscellaneous' },
  { value: '3110', label: '3110 Insurance' },
  { value: '3120', label: '3120 Marine Contract Actions' },
  { value: '3130', label: '3130 Miller Act' },
  { value: '3140', label: '3140 Negotiable Instruments' },
  { value: '3150', label: '3150 Recovery of Overpayment of Benefits' },
  { value: '3151', label: '3151 Overpayments Under Medicare Act' },
  { value: '3160', label: '3160 Stockholders\' Suits' },
  { value: '3190', label: '3190 Other Contract Actions' },
  { value: '3196', label: '3196 Franchise' },
  { value: '3210', label: '3210 Land Condemnation' },
  { value: '3220', label: '3220 Foreclosure' },
  { value: '3230', label: '3230 Rent, Lease, Ejectment' },
  { value: '3240', label: '3240 Torts to Land' },
  { value: '3245', label: '3245 Tort Product Liability' },
  { value: '3290', label: '3290 Other Real Property Actions' },
  { value: '3310', label: '3310 Airplane Personal Injury' },
  { value: '3315', label: '3315 Airplane Product Liability' },
  { value: '3320', label: '3320 Assault, Libel, and Slander' },
  { value: '3330', label: '3330 Federal Employers\' Liability' },
  { value: '3340', label: '3340 Marine Personal Injury' },
  { value: '3345', label: '3345 Marine - Product Liability' },
  { value: '3350', label: '3350 Motor Vehicle Personal Injury' },
  { value: '3355', label: '3355 Motor Vehicle Product Liability' },
  { value: '3360', label: '3360 Other Personal Injury' },
  { value: '3365', label: '3365 Personal Injury - Product Liability' },
  { value: '3368', label: '3368 Asbestos Personal Injury - Product Liability' },
  { value: '3370', label: '3370 Other Fraud' },
  { value: '3371', label: '3371 Truth In Lending' },
  { value: '3380', label: '3380 Other Personal Property Damage' },
  { value: '3385', label: '3385 Property Damage - Product Liability' },
  { value: '3400', label: '3400 State Re-Apportionment' },
  { value: '3410', label: '3410 Antitrust' },
  { value: '3422', label: '3422 Bankruptcy Appeals Rule 28 USC 158' },
  { value: '3423', label: '3423 Bankruptcy Withdrawal 28 USC 157' },
  { value: '3430', label: '3430 Banks and Banking' },
  { value: '3440', label: '3440 Other Civil Rights' },
  { value: '3441', label: '3441 Civil Rights Voting' },
  { value: '3442', label: '3442 Civil Rights Jobs' },
  { value: '3443', label: '3443 Civil Rights Accommodations' },
  { value: '3444', label: '3444 Civil Rights Welfare' },
  { value: '3445', label: '3445 Americans with Disabilities Act - Empl' },
  { value: '3446', label: '3446 Americans with Disabilities Act - Other' },
  { value: '3450', label: '3450 Interstate Commerce' },
  { value: '3460', label: '3460 Deportation' },
  { value: '3470', label: '3470 Civil (RICO)' },
  { value: '3480', label: '3480 Consumer Credit' },
  { value: '3490', label: '3490 Cable Satellite/TV' },
  { value: '3530', label: '3530 Habeas Corpus' },
  { value: '3535', label: '3535 Habeas Corpus: Death Penalty' },
  { value: '3540', label: '3540 Prisoner Petitions-Mandamus & Other' },
  { value: '3550', label: '3550 Prisoner - Civil Rights' },
  { value: '3555', label: '3555 Prison Condition' },
  { value: '3710', label: '3710 Fair Labor Standards Act' },
  { value: '3720', label: '3720 Labor/Management Relations Act' },
  { value: '3730', label: '3730 Report & Disclosure' },
  { value: '3740', label: '3740 Railway Labor Act' },
  { value: '3790', label: '3790 Other Labor Litigation' },
  { value: '3791', label: '3791 Employee Retirement' },
  { value: '3810', label: '3810 Selective Service' },
  { value: '3820', label: '3820 Copyright' },
  { value: '3830', label: '3830 Patent' },
  { value: '3840', label: '3840 Trademark' },
  { value: '3850', label: '3850 Securities, Commodities, Exch.' },
  { value: '3890', label: '3890 Other Statutory Actions' },
  { value: '3891', label: '3891 Agricultural Acts' },
  { value: '3892', label: '3892 Economic Stabilization Act' },
  { value: '3893', label: '3893 Environmental Matters' },
  { value: '3894', label: '3894 Energy Allocation Act' },
  { value: '3895', label: '3895 Freedom of Information Act of 1974' },
  { value: '3950', label: '3950 Constitutionality of State Statutes' },
  { value: '3990', label: '3990 Other' },
  { value: '3999', label: '3999 Miscellaneous' },
  { value: '4110', label: '4110 Insurance' },
  { value: '4120', label: '4120 Marine Contract Actions' },
  { value: '4140', label: '4140 Negotiable Instruments' },
  { value: '4150', label: '4150 Overpayments & Enforcement of Judgments' },
  { value: '4160', label: '4160 Stockholders Suits' },
  { value: '4190', label: '4190 Other Contract Actions' },
  { value: '4195', label: '4195 Contract Product Liability' },
  { value: '4196', label: '4196 Franchise' },
  { value: '4210', label: '4210 Land Condemnation' },
  { value: '4220', label: '4220 Foreclosure' },
  { value: '4230', label: '4230 Rent, Lease, Ejectment' },
  { value: '4240', label: '4240 Torts to Land' },
  { value: '4245', label: '4245 Tort Product Liability' },
  { value: '4290', label: '4290 Other Real Property Actions' },
  { value: '4310', label: '4310 Airplane Personal Injury' },
  { value: '4315', label: '4315 Airplane Product Liability' },
  { value: '4320', label: '4320 Assault, Libel, and Slander' },
  { value: '4340', label: '4340 Marine Personal Injury' },
  { value: '4345', label: '4345 Marine - Product Liability' },
  { value: '4350', label: '4350 Motor Vehicle Personal Injury' },
  { value: '4355', label: '4355 Motor Vehicle Product Liability' },
  { value: '4360', label: '4360 Other Personal Injury' },
  { value: '4362', label: '4362 Medical Malpractice' },
  { value: '4365', label: '4365 Personal Injury - Product Liability' },
  { value: '4368', label: '4368 Asbestos Personal Injury - Product Liability' },
  { value: '4370', label: '4370 Other Fraud' },
  { value: '4371', label: '4371 Truth in Lending' },
  { value: '4380', label: '4380 Other Personal Property Damage' },
  { value: '4385', label: '4385 Property Damage - Product Liability' },
  { value: '4440', label: '4440 Other Civil Rights' },
  { value: '4441', label: '4441 Civil Rights Voting' },
  { value: '4442', label: '4442 Civil Rights Jobs' },
  { value: '4443', label: '4443 Civil Rights Accommodations' },
  { value: '4444', label: '4444 Civil Rights Welfare' },
  { value: '4445', label: '4445 Americans with Disabilities Act - Empl' },
  { value: '4446', label: '4446 Americans with Disabilities Act - Other' },
  { value: '4470', label: '4470 Civil (RICO)' },
  { value: '4480', label: '4480 Consumer Credit' },
  { value: '4490', label: '4490 Cable Satellite/TV' },
  { value: '4555', label: '4555 Prisoner- Prison Condition' },
  { value: '4950', label: '4950 Constitutionality of State Statutes' },
  { value: '4990', label: '4990 Other' },
  { value: '4999', label: '4999 Miscellaneous' },
  { value: '5535', label: '5535 Habeas Corpus: Death Penalty' },
  { value: '5990', label: '5990 Other' },
  { value: '5992', label: '5992 Local Jurisdictional Appeal' },
  { value: 'ZZZ', label: 'Other Nature of Suit' },
];



// WEBPACK FOOTER //
// ./src/data/appellateNosOptions.js